import React from 'react';
import Link from 'next/link';

export const FinalCTA: React.FC = () => {
  return (
    <div className="mt-12 bg-linear-to-br from-gray-50 to-white border border-gray-200 rounded-lg p-8">
      <div className="max-w-3xl mx-auto text-center">
        {/* Headline */}
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-4">
          Ready to List Your Gear?
        </h2>
        <p className="text-2xl text-gray-600 mb-8">
          Use the insights above to price competitively and sell faster.
          GearFocus makes it easy to reach serious buyers.
        </p>

        {/* Primary CTA */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
          <Link
            href="/sell"
            className="w-full sm:w-auto px-8 py-4 bg-brand-orange text-white text-lg font-medium rounded-lg hover:bg-orange-600 transition-colors shadow-md hover:shadow-lg"
          >
            List an Item
          </Link>
          <a
            href="mailto:support@gearfocus.com"
            className="w-full sm:w-auto px-8 py-4 border-2 border-gray-300 text-gray-700 text-lg font-medium rounded-lg hover:bg-gray-50 transition-colors"
          >
            Need Help?
          </a>
        </div>

        {/* Secondary Links */}
        <div className="flex flex-wrap gap-6 justify-center text-3xl text-gray-600">
          <Link href="/policies/terms" className="hover:text-brand-orange transition-colors">
            View Policies
          </Link>
          <span className="text-gray-300">|</span>
          <a href="mailto:support@gearfocus.com" className="hover:text-brand-orange transition-colors">
            Contact Support
          </a>
          <span className="text-gray-300">|</span>
          <Link href="/sell" className="hover:text-brand-orange transition-colors">
            Seller Resources
          </Link>
        </div>

        {/* Divider */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-2xl text-gray-500 leading-relaxed">
            This page contains proprietary market data compiled by GearFocus.
            Please do not share or redistribute this information. For questions
            about this data, contact{' '}
            <a
              href="mailto:support@gearfocus.com"
              className="text-brand-orange hover:underline"
            >
              support@gearfocus.com
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};
